import { SecretValue } from "client/Api/Apps/common";
import { environmentHttpClient } from "client/Api/httpClient";

export type ZermeloConnectionModel = {
	id: number;
	name: string;
	serverUrl: string;
};

export type ZermeloConnectionListItemModel = {
	id: number;
	name: string;
	serverUrl: string;
};

export type ZermeloConnectionSaveModel = {
	name: string;
	serverUrl: string;
	apiKey: SecretValue;
};

export type NewConnectionZermeloSaveResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<ZermeloConnectionListItemModel>> {
	return environmentHttpClient.get<ReadonlyArray<ZermeloConnectionListItemModel>>(
		"UiApi/ZermeloConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<ZermeloConnectionModel> {
	return environmentHttpClient.get<ZermeloConnectionModel>(
		`UiApi/ZermeloConfiguration/${id}`,
		undefined,
		{
			signal
		}
	);
}

export function create(model: ZermeloConnectionSaveModel): Promise<NewConnectionZermeloSaveResultModel> {
	return environmentHttpClient.post<NewConnectionZermeloSaveResultModel>("UiApi/ZermeloConfiguration", model);
}

export function update(id: number, model: ZermeloConnectionSaveModel): Promise<void> {
	return environmentHttpClient.put<void>(`UiApi/ZermeloConfiguration/${id}`, model);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/ZermeloConfiguration",
		ids,
		{ signal }
	);
}
